import { render, staticRenderFns } from "./UserAnchorsTable.vue?vue&type=template&id=e23092ee&"
import script from "./UserAnchorsTable.vue?vue&type=script&lang=js&"
export * from "./UserAnchorsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAnchorsTable.vue?vue&type=style&index=0&id=e23092ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports